import { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { myWordsQuery } from "../../../../../validations/myWordsValidation";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function AddNewGroupOfWords(props) {
  const { addNewWordGroupInBack } = props;
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [nameOfgroup, setnameOfgroup] = useState("");

  const initialValues = {
    nameOfgroup: "",
  };

  const onSubmit = (values, props) => {
    let data = {
      nameOfgroup: values.nameOfgroup,
    };
    // console.log("newValuesValues", data);
    addNewWordGroupInBack(data);
  };

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        validationSchema={myWordsQuery}
        onSubmit={onSubmit}
      >
        {(props) => (
          <Form>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "25%" : "50%" }}
                    >
                      فیلتر لغات ذخیره شده
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "75%" : "50%" }}
                    >
                      {" "}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"نام گروه"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        type="text"
                        size="small"
                        as={TextField}
                        name="nameOfgroup"
                        label="نام گروه"
                        placeholder="نام گروه"
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="nameOfgroup" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Button
              type="submit"
              variant="contained"
              sx={{ m: 2 }}
              color="success"
            >
              ایجاد
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
